<template>
  <aw-drag tag="tr" @click="open()" :drag-item="item" class="cursor-pointer" :drag-start-timeout="300" :enable="dragEnabled">
    <td v-if="previews?.length" class="min-w-50 w-14 px-1 sm:p-0">
      <img :src="previews[0]" alt="" class="max-h-12 sm:max-h-full" />
    </td>

    <td v-else class="py-3 px-4 sm:px-3">
      <aw-icon
        :icon="item.type"
        class="w-6 h-6 text-gray-400 "
      ></aw-icon>
    </td>

    <td class="Table__Cell-Name py-2 px-3">
      <a :href="item.link ? item.link : item.url" ref="link" :target="item.link ? '_blank' : '_self'">
        <aw-icon
          v-if="item.type === 'folder'"
          :icon="item.link ? 'link' : 'folder'"
          class="w-4 h-4 "
        />
        <span class="pl-2">
          {{ showName }}
        </span>
      </a>
    </td>
    <td class="py-2 px-3 text-center whitespace-nowrap">
      <ui-pictogram v-if="item.published__user" :user="item.published__user" class="mr-2" />
      <span class="text-xs">{{ publishedDate }}</span>
    </td>
    <td class="py-2 px-3 text-center whitespace-nowrap" v-if="trash">
      <ui-pictogram v-if="item.deleted_by__user_id" :user="item.deleted_by__user" class="mr-2" />
      <span class="text-xs">{{ deletedDate }}</span>
    </td>
    <!--
    <td class="py-2 px-3 text-center whitespace-nowrap">
      <span class="Pictogram mr-2">VN</span>
      <span class="text-xs">at 15:23</span>
    </td>
    <td class="py-2 px-3 text-center whitespace-nowrap">
      <ui-pictogram class="mr-2">KD</ui-pictogram>
      <span class="text-xs">at 17:53</span>
    </td>
    -->
    <td class="py-2 px-2 text-right whitespace-nowrap">
      <!-- Mobile -->
      <div class="flex items-center justify-end cursor-pointer">
        <aw-icon
          icon="chevron-right"
          class="w-6 h-6 text-gray-400  "
        ></aw-icon>
      </div>

      <!-- Desktop -->
      <div class="flex items-center justify-end" v-if="!$presenter.isPublic && $route.matched[0].name !== 'BCSharedFolder'">
        <!--  eye -->

        <span class="inline-flex items-center mr-2.5" v-if="item.hidden || bookmarked || notPublished">
          <aw-icon
            icon="eye-closed"
            class="w-4 h-4  cursor-pointer text-red-600 hover:text-bc-blue"
            :class="{ '!mr-2': bookmarked || notPublished }"
            v-if="item.hidden"
            v-tippy="$t('Hidden')"
          ></aw-icon>
          <aw-icon
            icon="pen"
            class="w-4 h-4  cursor-pointer text-red-600 hover:text-bc-blue"
            :class="{ '!mr-2': bookmarked || item.hidden }"
            v-if="notPublished"
            v-tippy="$t('Document is not pusblished')"
          ></aw-icon>
          <aw-icon
            icon="star"
            class="w-4 h-4  cursor-pointer text-yellow-600 hover:text-bc-blue"
            v-if="bookmarked"
            v-tippy="$t('Pinned')"
          ></aw-icon>
        </span>
        <span
          ref="DocumentCircle"
          :data-item-index="rank"
          class="DocumentCircle inline-flex items-center mr-2.5"
          :class="{
            'DocumentCircle--active': bcSelectedStore.selected.has(item.url)
          }"
          @click.stop="bcSelectedStore.select(
            item, 
            {
              isRecursive: true,
              isShift: $event.shiftKey,
              itemIndex: rank,
            }
          )"
        ></span>
        <span
          class="inline-flex items-center cursor-pointer text-gray-400 hover:text-gray-500"
        >
          <aw-dropdown
            placement="bottom-end"
            :offset="[0, 6]"
            class="cursor-pointer inline-flex items-center"
            v-if="!$presenter.isPublic"
          >
            <template v-slot:btn="{ toggle }">
              <div @click.stop="toggle" class="inline-flex items-center">
                <aw-icon
                  icon="dots"
                  class="w-4 h-4 -mx-1 "
                ></aw-icon>
              </div>
            </template>
            <template v-slot:dropdown="{ opened, dropdown, close }">
              <div
                v-show="opened"
                :ref="dropdown"
                class="Dropdown Dropdown--Hover absolute rounded-md bg-white max-w-xs text-sm top-full right-0 shadow-md z-10"
              >
                <folder-dropdown :item="item" @onselect="close" trash="trash" />
              </div>
            </template>
          </aw-dropdown>
        </span>
      </div>
    </td>
  </aw-drag>
</template>

<script>
import formatDate from 'nette-base-module/js/utils/formatDate'
import FolderListItem from '../../mixins/FolderListItem'
import Selected from '../../mixins/Selected'

export default {
  mixins: [
    FolderListItem,
    Selected,
  ],
  props: {
    trash: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    publishedDate() {
      return formatDate(this.item.published, 'd. m. Y')
    },
    deletedDate() {
      return formatDate(this.item.deleted, 'd. m. Y')
    },
    showName() {
      if (!this.trash || !this.item.path) {
        return this.item.name
      }
      const parts = this.item.path.split('/')
      parts.shift()
      let ret = parts.join('/')
      if (this.item.type == 'document') {
        ret += ' / ' + this.item.name
      }
      return ret
    }
  },
  mounted() {
    this.assignItemToSelectBtn('DocumentCircle', this.item)
  }
}
</script>

<style lang="scss" scoped>
td:last-child {
  > div:first-child {
    @apply hidden;
  }

  > div:first-child + div {
    @apply flex;
  }
}

@media (max-width: 600px) {
  td:nth-child(3),
  td:nth-child(4) {
    @apply hidden;
  }

  td:last-child {
    > div:first-child {
      @apply flex;
    }

    > div:first-child + div {
      @apply hidden;
    }
  }
}
</style>
